// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductMaterial extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  public static Materials = {
    Delivery: 709,
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  displayOrder?: number;
  name?: string;
  notes?: string;
  trackInventory!: boolean;
}

